import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate} from '@angular/common';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InboxService {

  constructor(private http: HttpClient) { }

  InboxData: any[] = [];
  loading = false;
  private request: Subscription | null = null;

  getList(from: Date, to: Date){
    // Only the latest range may fill the list: every date change used to start another request
    // beside the ones still running, and whichever answered last won - an older range included.
    // Unsubscribing aborts the request.
    this.request?.unsubscribe();
    this.InboxData = [];
    this.loading = true;
    this.request = this.http.get<any[]>('/api/inboxes/'+formatDate(from,"yyyy-MM-dd",'en-US') +'/' + formatDate(to,"yyyy-MM-dd",'en-US')).subscribe({
      next: (data) => {
        this.InboxData = Array.isArray(data) ? data : [];
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.log(error);
      }
    });
  }


}
